import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2145b2e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["src"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: "QRCode ub ub-ver",
    style: _normalizeStyle({'width':_ctx.width+'px', 'height':_ctx.height+'px'})
  }, [
    _createElementVNode("canvas", {
      id: _ctx.canvasId,
      style: _normalizeStyle({'width':_ctx.width+'px', 'height':_ctx.height+'px',position:'absolute',opacity:0})
    }, null, 12, _hoisted_1),
    _createElementVNode("img", {
      src: _ctx.url,
      style: _normalizeStyle({'width':_ctx.width+'px', 'height':_ctx.height+'px'})
    }, null, 12, _hoisted_2)
  ], 4))
}